document
  .querySelectorAll('.js-button')
  .forEach(
    button =>
      (button.innerHTML =
        '<div><span>' +
        button.textContent.trim().split('').join('</span><span>') +
        '</span></div>')
  );
